// 枚举类型
interface ItemType {
    title: string;
    value: number;
}

//任务类型枚举
export const taskTypeEnum: ItemType[] = [
    {
        title: '入库',
        value: 0
    },
    {
        title: '出库',
        value: 1
    }
]


//出入库记录--类型枚举
export const outInTypeEnum: ItemType[] = [
    {
        title: '入库',
        value: 0
    },
    {
        title: '出库',
        value: 1
    }
]

//库位是否自动枚举
export const isAutoEnum: ItemType[] = [
    {
        title: '否',
        value: 0
    },
    {
        title: '是',
        value: 1
    }
]

//工厂枚举
export const factoryEnum: ItemType[] = [
    {
        title: '昆山',
        value: 1
    },
    {
        title: '武汉',
        value: 2
    }
]

//备件中心枚举
export const partsEnum: ItemType[] = [
    {
        title: '昆山牧野备件中心',
        value: 1
    },
    {
        title: ' 武汉牧野备件中心',
        value: 2
    }
]
//仓库所属地区列表
export const regionEnum: ItemType[] = [
    {
        title: '昆山牧野',
        value: 1
    },
    {
        title: '武汉牧野',
        value: 2
    }
]
//是否虚拟
export const isvirtualEnum: ItemType[] = [
    {
        title: '否',
        value: 0
    },
    {
        title: '是',
        value: 1
    }
]

export const sexEnum: ItemType[] = [
    {
        title: '男',
        value: 1
    },
    {
        title: '女',
        value: 2
    }
]

//状态
export const statusEnum: ItemType[] = [
    {
        title: '正常',
        value: 0
    },
    {
        title: '冻结',
        value: 1
    }
]

export const statusEnum_another: ItemType[] = [
    {
        title: '正常',
        value: 0
    },
    {
        title: '停用',
        value: 1
    },
]

export const menuTypeList: ItemType[] = [
    {
        title: '目录',
        value: 0
    },
    {
        title: '菜单',
        value: 1
    }
]


export const laneEnums: ItemType[] = [
    {
        title: '巷道1',
        value: 1
    },
    {
        title: '巷道2',
        value: 2
    },
    {
        title: '巷道3',
        value: 3
    },
    {
        title: '巷道4',
        value: 4
    },
    {
        title: '巷道5',
        value: 5
    },
    {
        title: '巷道6',
        value: 6
    },
    {
        title: '巷道7',
        value: 7
    },
    {
        title: '巷道8',
        value: 8
    },
    {
        title: '巷道9',
        value: 9
    },
    {
        title: '巷道10',
        value: 10
    },
]

//工量具历史记录--类型枚举
export const waretoolflowingEnum: ItemType[] = [
    {
        title: '借用',
        value: 0
    },
    {
        title: '报废',
        value: 1
    },
    {
        title: '归还',
        value: 2
    },
    {
        title: '入库',
        value: 3
    }
]
   